import { Alert, Stack } from "@mui/material";
import { FormEvent } from "react";

import Input, { InputType } from "../../../components/forms/Input";
import Button from "../../../components/theme/Button";
import useFetch from "../../../hooks/useFetch";
import { Step } from "../show";

import FinishedStep from "./FinishedStep";

const FeedbackStep: Step = ({ setStep }) => {
  const [putFeedback, { error: feedbackError, loading: feedbackLoading }] =
    useFetch(window.location.href.replace("details", "feedback"), {
      method: "PUT",
      onSuccess: () => setStep(FinishedStep),
    });

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    const formData = new FormData(event.target as HTMLFormElement);

    putFeedback({
      feedback: {
        feedback: formData.get("feedback"),
      },
    });
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <p>Bedankt! We horen graag hoe deze website is bevallen.</p>
        <Stack spacing={1}>
          <Input
            autoFocus
            required
            label="Heb je feedback voor ons?"
            name="feedback"
            placeholder="Feedback"
            type={InputType.TextArea}
          />
        </Stack>
        {feedbackError && (
          <Alert severity="error" sx={{ marginTop: "1em" }}>
            {feedbackError}
          </Alert>
        )}
        <Stack direction="row" justifyContent="end">
          <Button
            loading={feedbackLoading}
            sx={{ marginTop: "1em" }}
            type="submit"
            variant="contained"
          >
            Verstuur
          </Button>
        </Stack>
      </form>
    </>
  );
};

export default FeedbackStep;
